export default class SizeObserverCssVariables {
	constructor(cssVariablePrefix = "single-video", targetSel = false, setVariablesInElement = false ) {
		this.cssVariablePrefix = cssVariablePrefix;
		this.targetSel = targetSel;
		this.sizeObserver = false;
		this.setVariablesInElement = setVariablesInElement;
	}
	async setVideoHeightObserver() {
		let target = this.targetSel && document.querySelector(this.targetSel);
		const setSizeCssVar = () => {
			let variableInElement = typeof this.setVariablesInElement === 'function' ? this.setVariablesInElement() : document.documentElement;
			if( variableInElement ){
				let h = target.clientHeight;
				let w = target.clientWidth;
				document.documentElement.style.setProperty(`--${this.cssVariablePrefix}-h`, h + "px");
				document.documentElement.style.setProperty(`--${this.cssVariablePrefix}-w`, w + "px");
			}
		};

		if (target) {
			this.sizeObserver && this.sizeObserver.disconnect();
			this.sizeObserver = new ResizeObserver(setSizeCssVar).observe(target);
		}
	}
}
